import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { FormControl, FormGroup, Input } from 'rsuite';
import { EquipmentContext } from '../utils/scope';
import { fetchProductFiltersList } from './../api';
import { useLocation } from './../hooks/useLocation';
import { CategoriesCombo } from './CategoriesCombo';
import { Filter } from './Filter';

export const ToolbarFilters = () => {
  const {
    params: { s, category },
    go,
  } = useLocation();

  const scope = useContext(EquipmentContext);

  const [search, setSearch] = useState(s || '');

  useEffect(() => {
    setSearch(s || '');
  }, [s, setSearch]);

  let { data } = useQuery([scope, 'product-filters', category], fetchProductFiltersList);

  return (
    <div className="nh-toolbar-left">
      <FormGroup>
        <FormControl
          className="nh-search"
          // style={{ width: 100 }}
          placeholder={'Search...'}
          accepter={Input}
          value={search}
          onChange={setSearch}
          onPressEnter={() => {
            go({ s: search });
          }}
        />
        <CategoriesCombo />
      </FormGroup>
      <FormGroup>
        {[...(data?.filters || [])]
          .filter((f) => f.field !== 'slider')
          .map((filter) => {
            return <Filter key={filter.name} filter={filter} />;
          })}
      </FormGroup>
    </div>
  );
};
